import { useEffect, useState } from 'react'

import { ProductFruits } from 'react-product-fruits'

import { parseJWT } from 'src/utils/parseJwt'
import { useParams } from 'react-router-dom'
import { PathParams } from 'src/pages/communityHome'
import { getProductFruitsLocale } from 'src/context/productFruits/utils/getProductFruitsLocale'
import { oneMs } from './constants'
import { LANG_ISO_639_1 } from './enums'
import type { ProductFruitsComponentProps, ProductFruitsUser, UserToken } from './types'

const ProductFruitsComponent = ({
  productFruitsWorkspaceCode,
  userToken,
  userCustomProps
}: ProductFruitsComponentProps) => {
  const [productFruitsUser, setProductFruitsUser] = useState<ProductFruitsUser>()
  const [productFruitsLang, setProductFruitsLang] = useState<LANG_ISO_639_1>(LANG_ISO_639_1.EN)
  const { lang } = useParams<PathParams>();

  useEffect(() => {
    if (!userToken) return

    const token = parseJWT(userToken) as UserToken

    if (token?.ucode) {
      const authTimeMs = token.auth_time * oneMs
      setProductFruitsUser({
        username: token.ucode,
        email: token.email,
        firstname: token.name,
        signUpAt: new Date(authTimeMs).toISOString(),
        props: userCustomProps
      })
    }
  }, [userToken, userCustomProps])

  useEffect(() => {
    if (!lang) return

    const lng = getProductFruitsLocale(lang);

    LANG_ISO_639_1?.[lng] && setProductFruitsLang(LANG_ISO_639_1[lng])
  }, [lang])

  if (!productFruitsUser?.username) {
    return null
  }

  return (
    <ProductFruits
      workspaceCode={productFruitsWorkspaceCode}
      language={productFruitsLang}
      user={productFruitsUser}
    />
  )
}

export default ProductFruitsComponent
